package com.arena_web.ui.components.widgets

import androidx.compose.runtime.Composable
import com.arena_web.ui.utils.s
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Img

/**
 * Inline Arena-coin glyph rendered next to a coin amount ("20 ⓒ") — the same
 * asset the wallet dialog uses, so every monetised action reads consistently.
 * Sized via the shared s() scale like the surrounding text.
 */
@Composable
fun CoinIcon(size: Int = 20) {
    Img(
        src = "/images/coins/coin.png",
        attrs = {
            attr("alt", "coins")
            attr("draggable", "false")
            style {
                property("width", s(size))
                property("height", s(size))
                property("object-fit", "contain")
                property("display", "block")
                property("flex-shrink", "0")
            }
        },
    )
}

/**
 * Formats a backend coin amount ("20.00") as the number users see next to the
 * coin glyph ("20"). Fractional amounts keep their decimals.
 */
fun formatCoins(raw: String): String {
    val parsed = raw.toDoubleOrNull() ?: return raw
    return if (parsed == parsed.toLong().toDouble()) {
        parsed.toLong().toString()
    } else {
        parsed.toString()
    }
}
